import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingLabel: {
		id: 'software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label',
		defaultMessage: 'Loading',
		description: 'The aria-label for the dropdown item that is loading.',
	},
});
export default messages;
